import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { ChannelImage, DateSpan, Description, Entry, Header, ImageContainer, ProgramInformation, SubTitle, Title } from './ProgramEntry.styles';
import { ProgramEntryPlayLink } from './ProgramEntryPlayLink';
import SvgInfo from '../../../../../play-core/icons/Info';
import { Colors } from '../../../../../play-core/styles/Colors';
import { TvLogo } from '../../ChannelLogo/TvLogo';
import { IconWrapper } from '../../IconWrapper/IconWrapper';
import { PlayImage } from '../../Image/PlayImage';
import { localTimeSpan } from '../../TvGuide/tv-guide-types';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ProgramEntry = ({
  program,
  channel,
  entryTitle,
  entrySubtitle,
  onSelect,
  showChannelIcon = true,
  showImage = true,
  analyticsPageId
}) => {
  const {
    t
  } = useTranslation();
  const useChannelFallback = program.imageIsFallbackUrl && channel?.type === 'non-srg';
  const imageUrl = useChannelFallback ? channel?.imageUrlRaw : program.imageUrl;
  return /*#__PURE__*/_jsxs(Entry, {
    "aria-label": `${entryTitle ? `${entrySubtitle} - ` : ''} ${program.title} - ${t('global.moreInformation')}`,
    onClick: onSelect,
    showFirstColumn: showImage,
    "data-testclass": "program-entry",
    children: [showImage && /*#__PURE__*/_jsx(ImageContainer, {
      children: imageUrl && /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(PlayImage, {
          alt: program.title,
          src: imageUrl,
          aspectRatio: '3/2',
          width: 320,
          objectFit: useChannelFallback ? 'contain' : 'cover'
        }), showChannelIcon && program.channelTitle && /*#__PURE__*/_jsx(ChannelImage, {
          hideInViewport: 'mediumUp',
          alt: program.channelTitle,
          src: TvLogo(program.channelTitle)
        })]
      })
    }), /*#__PURE__*/_jsxs(ProgramInformation, {
      children: [/*#__PURE__*/_jsxs(Header, {
        children: [channel && /*#__PURE__*/_jsx(ProgramEntryPlayLink, {
          program: program,
          channel: channel,
          iconSize: 26,
          analyticsPageId: analyticsPageId
        }), showChannelIcon && program.channelTitle && /*#__PURE__*/_jsx(ChannelImage, {
          hideInViewport: 'small',
          alt: program.channelTitle,
          src: TvLogo(program.channelTitle)
        }), /*#__PURE__*/_jsx(DateSpan, {
          children: program.isFollowUp ? t('tvGuide.afterwards') : localTimeSpan(program.startTime, program.endTime)
        }), program.broadcastInfo && /*#__PURE__*/_jsx(InfoIcon, {
          size: 22,
          title: program.broadcastInfo,
          icon: /*#__PURE__*/_jsx(SvgInfo, {})
        })]
      }), /*#__PURE__*/_jsx(Title, {
        children: entryTitle || entrySubtitle
      }), entryTitle && entrySubtitle && /*#__PURE__*/_jsx(SubTitle, {
        children: entrySubtitle
      }), (program.lead || program.description) && /*#__PURE__*/_jsx(Description, {
        children: program.lead || program.description
      })]
    })]
  });
};
const InfoIcon = styled(IconWrapper).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "ProgramEntry__InfoIcon",
  componentId: "sc-1ita6cf-0"
})(["color:", ";margin-left:16px;"], Colors.GREY_d2d2d2);